import { defineStore } from "pinia";


interface AppStoreState {
    showDrawer: boolean;
}

export const useAppStore = defineStore("AppStore", {
    state: (): AppStoreState => ({
        showDrawer: false,
    }),
    actions: {

        openDrawer(): void {
            document.body.style.overflow = "hidden";
            this.showDrawer = true;
        },
        closeDrawer(): void {
            document.body.style.overflow = "auto";
            this.showDrawer = false;
        },
    },
});
